module.exports = __webpack_public_path__ + "img/Eventos_descargar_folio.f446e8f2.svg";